import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AdvancingParticipantsPanel } from "advancing/components/AdvancingParticipantsPanel";
import { InviteParticipantModal } from "advancingapprove/components/InviteParticipantModal";
import { getApproveSidePanelQuery } from "advancingapprove/utils";
import { DeleteDialog } from "components";
import React, { useState } from "react";
import { useLoaderData } from "react-router";
import { useCustomQuery } from "utilities/hookutils";

export const ParticipantsTab = () => {
  const { advancingSession } = useLoaderData<server.viewmodel.AdvancingApproveFrontModel>();
  const sidePanelQueryOptions = getApproveSidePanelQuery(advancingSession.advancingSessionId);
  const sidePanelQuery = useCustomQuery(sidePanelQueryOptions);
  const queryClient = useQueryClient();
  const [isInviteModalOpen, setIsInviteModalOpen] = useState(false);
  const [deletingParticipant, setDeletingParticipant] = useState<server.dto.AdvancingParticipant>();

  const deleteMutation = useMutation({
    mutationFn: (advancingParticipantId: number) => window.CoreApi.AdvancingSession.DeleteParticipant(advancingParticipantId, { toastOnError: true }).then(r => r.data),
    onSuccess: async response => {
      if (response.hasErrors) return;
      await queryClient.invalidateQueries({ queryKey: sidePanelQueryOptions.queryKey });
      setDeletingParticipant(undefined);
    }
  });

  const onInvited = () => {
    setIsInviteModalOpen(false);
    queryClient.invalidateQueries({ queryKey: sidePanelQueryOptions.queryKey });
  };

  return <>
    <AdvancingParticipantsPanel
      participants={sidePanelQuery.data?.data.participants ?? []}
      isLoading={sidePanelQuery.isLoading}
      approverActions={{
        onInvite: () => setIsInviteModalOpen(true),
        onDelete: setDeletingParticipant
      }}
    />

    {isInviteModalOpen && <InviteParticipantModal
      advancingSessionId={advancingSession.advancingSessionId}
      showId={advancingSession.show.showId}
      onInvited={onInvited}
      onClose={() => setIsInviteModalOpen(false)}
    />}

    <DeleteDialog
      isOpen={deletingParticipant != null}
      message={RESX.Advancing.DeleteInvitationWarning}
      handleClose={() => setDeletingParticipant(undefined)}
      onDelete={() => deleteMutation.mutateAsync(deletingParticipant.advancingParticipantId)}
    />
  </>;
};
